import { GetterTree } from 'vuex';
import { RootState } from '../../types';
import { AppointmentMessageState } from './types';

export const getters: GetterTree<AppointmentMessageState, RootState> = {
  ['getMessages']: state => state.messages,
  ['messagesIsLoading']: state => state.isLoading,
};
